import { Pill, PillList } from "../../../entities/pill";
import pillRepository from "../../../../infrastructure/repository/impl/pill/pill_repository";
import PillUseCasesInterface from "./pillInterface";

class PillUseCases implements PillUseCasesInterface {
  async list(index: number): Promise<PillList> {
    return await pillRepository.list(index);
  }

  async get(id: number): Promise<Pill> {
    return await pillRepository.get(id);
  }

  async watch(id: number): Promise<void> {
    await pillRepository.watch(id);
  }
}

export default new PillUseCases() as PillUseCasesInterface;
